<template>
  <div id="app" :class="{ menu_opened }">
    <router-view />
    <div v-if="menu_opened" class="mobile-menu-bg"></div>
    <ui-snackbar-container
      ref="snackbarContainer"
      position="right"
      transition="slide"
      :allowHtml="true"
      :queue-snackbars="false"
    ></ui-snackbar-container>
    <div class="loading" v-if="app.loading">
      <ui-progress-circular
        :stroke="5"
        :size="100"
        class="progress"
      ></ui-progress-circular>
    </div>
    <OnboardingModal
      @close="showHelp = false"
      v-if="showHelp && !isMobile"
    ></OnboardingModal>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import OnboardingModal from "@/components/modals/Onboarding";

export default {
  components: {
    OnboardingModal
  },
  data() {
    return {
      showHelp: false,
      menu_opened: false,
      isMobile: false
    };
  },
  computed: {
    ...mapState(["app"])
  },
  methods: {
    ...mapActions(["appStart"]),
    createSnackbar(msg) {
      this.$refs.snackbarContainer.createSnackbar({
        message: msg,
        duration: 3000
      });
    }
  },
  created() {
    this.isMobile = window.innerWidth < 768;
    this.$eventBus.$on("showHelp", () => {
      this.showHelp = true;
    });
    this.$eventBus.$on("mobile_menu_opened", state => {
      /**
       * state = true - значит включаем бекграунд меню для мобильных устройств
       * state = false - значит выключаем бекграунд меню для мобильных устройств
       */
      this.menu_opened = state;
      state
        ? document.querySelector("body").classList.remove("o-hidden")
        : document.querySelector("body").classList.add("o-hidden");
      document.querySelector("body").classList.contains("o-hidden")
        ? document.querySelector("body").classList.remove("o-hidden")
        : document.querySelector("body").classList.add("o-hidden");
    });
    this.$eventBus.$on("serverSyncSuccess", payload => {
      const { msg } = payload;
      const html = `<svg class="check" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path fill="#4caf50" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
    </svg> ${msg}`;
      this.createSnackbar(html);
    });
    this.$eventBus.$on("serverSyncError", payload => {
      const { msg } = payload;
      const html = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path fill="red" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
</svg>
${msg}`;
      this.createSnackbar(html);
    });
    this.$eventBus.$on("showError", payload => {
      const { error } = payload;
      this
        .createSnackbar(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none"/>
    <path fill="red" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
</svg>
${error}`);
    });
    // try to get login data
  },
  mounted() {
    window.onbeforeunload = () => {
      if (
        this.$store.state.user &&
        this.$store.state.user.step < 4 &&
        !this.$store.state.page.enabled
      ) {
        return true;
      }
    };
    (function(d, w, c) {
      (w[c] = w[c] || []).push(function() {
        try {
          // eslint-disable-next-line
          w.yaCounter50851889 = new Ya.Metrika2({
            id: 50851889,
            clickmap: true,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: true
          });
          // eslint-disable-next-line
        } catch (e) {
        }
      });

      const n = d.getElementsByTagName("script")[0];
      const s = d.createElement("script");
      const f = function() {
        n.parentNode.insertBefore(s, n);
      };
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://mc.yandex.ru/metrika/tag.js";

      if (w.opera == "[object Opera]") {
        d.addEventListener("DOMContentLoaded", f, false);
      } else {
        f();
      }
    })(document, window, "yandex_metrika_callbacks2");
  }
};
</script>

<style lang="scss" scoped>
#app {
  /*min-width: 1024px;*/
  position: relative;

  &.menu_opened {
    overflow: hidden;
  }
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
}

.mobile-menu-bg {
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  background: rgba(51, 51, 51, 0.3);
  width: 100%;
  height: 100vh;
  overflow: hidden;
}
</style>
